<template>
    <div class="card rounded-16">
        <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
            <b class="text-16">Your fitting</b>
        </div>
        <div class="card-body row">
            <div class="col-12" :class="fitter.mobile == 0 ? 'col-sm-5' : ''">
                <div class="row">
                    <div class="col-12" v-if="flashData">
                        <order-alerts
                            :flash-data="flashData"
                        ></order-alerts>
                    </div>
                    <div v-if="fitter.mobile == 0" class="col-12 text-capitalize gap-3">
                        <b class="d-block mb-2">{{ fitter.name.toLowerCase() }}</b>
                        <span class="d-block" v-if="fitter.address_line_one">{{ fitter.address_line_one.toLowerCase() }}</span>
                        <span class="d-block" v-if="fitter.address_line_two">{{ fitter.address_line_two.toLowerCase() }}</span>
                        <span class="d-block" v-if="fitter.address_line_three">{{ fitter.address_line_three.toLowerCase() }}</span>
                        <span class="d-block">{{ fitter.postcode }}</span>
                    </div>
                    <div v-else class="col-12 col-sm-6 text-capitalize">
                        <b class="d-block my-3">{{ fitter.name.toLowerCase() }}</b>
                    </div>
                    <div class="col-12 mt-2" :class="fitter.mobile == 1 ? 'col-sm-6' : ''">
                        <fitter-date-time
                            :errors="errors"
                            :fitter="fitter"
                            :mobile-fitting-slots="mobileFittingSlots"
                            :custom-slot-count="customSlotCount"
                            :update-fitting-date="true"
                            :update-fitting-time="true"
                            :selected-fitting-date="appDate"
                            :selected-fitting-time="appTime"
                            :selected-fitting-end-time="basketAppEndTime"
                            :fittingTimes="this.fitterTimes"
                        ></fitter-date-time>
                        <div class="col-12" v-if="fitter.mobile == 1 && fitter.cal_account_number != 'CALTOTD'">
                            <p class="mb-2">The fitter will contact you with a fitting time estimate.</p>
                        </div>
                        <new-order-in-next
                            v-if="fitter?.cut_off && showOrderInNext"
                            :fitter="fitter"
                            background="alert-info"
                            class="d-flex align-items-center d-sm-block my-2"
                        ></new-order-in-next>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-7" v-if="fitter.mobile == 0">
                <fitter-map
                    :fitters="fitters"
                    :google-maps-api-key="googleMapsApiKey"
                    :postcode-details="postcodeDetails"
                    :session-postcode="sessionPostcode"
                    view="checkout"
                ></fitter-map>
            </div>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import helpers from '@shared/mixins/helpers';
    
    export default {
        props: [
            'fitter',
            'sessionPostcode',
            'addresses',
            'sameAsBilling',
            'basketAppDate',
            'basketAppTime',
            'basketAppEndTime',
            'postcodeDetails',
            'googleMapsApiKey',
            'errors',
            'customSlotCount',
            'mobileFittingSlots',
            'totdFittingSlots',
            'showOrderInNext'
        ],
        emits: ['toggleShippingFields'],
        inject: ['flashData'],
        mixins: [helpers],
        components: { Field, ErrorMessage },
        data() {
            return {
                appDate: this.basketAppDate,
                appTime: this.basketAppTime,
                fitters: [
                    this.fitter
                ],
                fitterTimes: this.fitter.cal_account_number == 'CALTOTD' ? this.totdFittingSlots : this.fitter.fitting_times
            }
        },
        mounted() {
            this.sortMapIcons(this.fitters);
        },
        methods: {
            toggleShipping() {
                this.$emit('toggleShippingFields');
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>